import { Injectable } from "@angular/core";
import { GlobalContants } from "../constants/global.contants";
import { v7 as uuidv7 } from 'uuid';
@Injectable({
    providedIn: 'root'
})

export class StoreService {

    public add(key: string, data: any) {
        const match = localStorage.getItem(key);
        if (match) {
            localStorage.removeItem(key);
        }
        const dataString = JSON.stringify(data);
        localStorage.setItem(key, dataString);
    }

    public get<T>(key: string) {
        const dataString = localStorage.getItem(key) as string;
        const data = JSON.parse(dataString);
        const typedData = data as T;
        return typedData;
    }

    public clear(key: string) {
        localStorage.removeItem(key);
    }

    public clearAll() {
        let lang = this.get(GlobalContants.StoreKey.CurrentLangID);
        let langCode = this.get(GlobalContants.StoreKey.CurrentLang);
        let currentRoute = this.get(GlobalContants.StoreKey.currentRoute);
        localStorage.clear()
        sessionStorage.clear();
        this.add(GlobalContants.StoreKey.CurrentLangID, lang);
        this.add(GlobalContants.StoreKey.CurrentLang, langCode);
        // this.add(GlobalContants.StoreKey.currentRoute, currentRoute);
    }

    public async addSessionData(key: string, data: any) {
        const match = sessionStorage.getItem(key);
        if (match) {
            sessionStorage.removeItem(key);
        }
        const dataString = JSON.stringify(data);
        sessionStorage.setItem(key, dataString);
    }

    public getSessionData<T>(key: string) {
        const dataString = sessionStorage.getItem(key) as string;
        const data = JSON.parse(dataString);
        const typedData = data as T;
        return typedData;
    }

    public clearSessionData(key: string) {
        sessionStorage.removeItem(key);
    }


    //set and get cookie 
    public setCookie(cname: any, cvalue: any, exdays: any) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    public getCookie(cname: any): string {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
        return "";
    }

    public setSession() {
         if (!this.getCookie('anonymous_session')) {
            let session_id = uuidv7();
            if (session_id) {
                this.setCookie('anonymous_session', session_id, 1);
            }
         }
    }

    public getSession(): string{
        return this.getCookie('anonymous_session') || '';
    }
}
